import React from 'react'
import type { Activity } from '@paintscout/api'
import { formatName } from '@paintscout/util/src/builder/util'
import Highlight from '@paintscout/ui/components/Highlight'

export interface ActivityOwnerProps {
  name?: string
  activity: Activity
  /**
   * Defaults to ' by '
   */
  prefix?: string
}

/**
 * Renders "by firstName lastName" if there is an owner, otherwise renders nothing
 */
export default function ActivityOwner(props: { activity: Activity; prefix?: string }) {
  const { activity, prefix = ' by ' } = props

  const isAutomaticDealStageChange =
    activity.details.activityType === 'deal-stage-changed' && activity.details.isAutomated
  const owner = isAutomaticDealStageChange ? activity.details.quoteOwner : activity.details.owner
  const name = formatName(owner)

  if (!name) {
    return null
  }

  return (
    <>
      {prefix}
      <Highlight>{name}</Highlight>
    </>
  )
}
